"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Sizes;

(function (Sizes) {
  Sizes["SMALL"] = "lsg--logo__small";
  Sizes["AUTO"] = "lsg--logo__auto";
  Sizes["BIG"] = "lsg--logo__big";
})(Sizes || (Sizes = {}));

exports.Sizes = Sizes;
var Variants;

(function (Variants) {
  Variants["MONOCHROME"] = "lsg--logo__monochrome";
  Variants["COLORED"] = "lsg--logo__colored";
})(Variants || (Variants = {}));

var Logo =
/** @class */
function (_super) {
  __extends(Logo, _super);

  function Logo() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.uuid = uniqid_1["default"]("Logo-");
    return _this;
  }

  Logo.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        href = _a.href,
        size = _a.size,
        variant = _a.variant,
        id = _a.id;
    var uuid = id || this.uuid;
    var Component = href ? "a" : "span"; // TODO check URL and disable link if already on the target URL

    return React.createElement("span", {
      id: uuid,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "logo", className, CSSPrefix_1.prefixEnumClassNames(size), CSSPrefix_1.prefixEnumClassNames(variant)])
    }, React.createElement(Component, __assign({}, {
      href: href
    }, {
      className: CSSPrefix_1.lsgPre + "logo-link"
    }), React.createElement("span", {
      className: CSSPrefix_1.lsgPre + "logo-colored"
    }, React.createElement("svg", {
      className: CSSPrefix_1.lsgPre + "logo-svg " + CSSPrefix_1.lsgPre + "logo-big",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1200 160",
      focusable: "false"
    }, React.createElement("defs", null, React.createElement("radialGradient", {
      id: uuid + "aNeues_Verlaufsfeld_2",
      cx: "742.78",
      cy: "92.85",
      r: "36.47",
      gradientTransform: "matrix(3.91 0 0 3.91 -1736.04 -221.2)",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      offset: "0",
      stopColor: "#ffe319"
    }), React.createElement("stop", {
      offset: ".2",
      stopColor: "#fdd70d"
    }), React.createElement("stop", {
      offset: ".48",
      stopColor: "#facb00"
    }), React.createElement("stop", {
      offset: ".63",
      stopColor: "#f8c700"
    }), React.createElement("stop", {
      offset: ".78",
      stopColor: "#f1bb00"
    }), React.createElement("stop", {
      offset: ".89",
      stopColor: "#eaae00"
    }), React.createElement("stop", {
      offset: ".92",
      stopColor: "#e4a500"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#d89300"
    })), React.createElement("radialGradient", {
      id: uuid + "aNeues_Verlaufsfeld_2-2",
      cx: "733.03",
      cy: "56.59",
      r: "36.4",
      xlinkHref: "#" + uuid + "aNeues_Verlaufsfeld_2"
    }), React.createElement("radialGradient", {
      id: uuid + "aNeues_Verlaufsfeld_2-3",
      cx: "706.75",
      cy: "83.25",
      r: "36.31",
      xlinkHref: "#" + uuid + "aNeues_Verlaufsfeld_2"
    }), React.createElement("radialGradient", {
      id: uuid + "aNeues_Verlaufsfeld_2-4",
      cx: "742.78",
      cy: "92.7",
      r: "36.47",
      xlinkHref: "#" + uuid + "aNeues_Verlaufsfeld_2"
    })), React.createElement("g", null, React.createElement("path", {
      d: "M1118.62 5.07A28.25 28.25 0 0 1 1130.15.7c2.6-.28 11.15-.17 20.9-.17a.14.14 0 0 1 .1.06l-.26-.43a1.58 1.58 0 0 0-.89-.06h-18.46c-2.58 0-12.56 0-24.11 14l.45.54a51.57 51.57 0 0 1 10.74-9.57z",
      style: {
        fill: "url(#" + uuid + "aNeues_Verlaufsfeld_2)"
      },
      transform: "translate(0 -.1)"
    }), React.createElement("path", {
      d: "M1136.86.1h-72.38a.12.12 0 0 0-.1 0l-36.24 62.78-11.37 19.68-1.32 2.29-.17.29a.08.08 0 0 0 0 .11l34.88 60.43a6.72 6.72 0 0 0-.37-.88c-.73-1.37-1.28-2.43-1.58-3.1a28.18 28.18 0 0 1-2-12.18c.58-11.58 6.73-23 9.81-28.36 7.27-12.58 21.31-36.89 21.31-36.89s14-24.32 21.29-36.9c3.09-5.35 9.92-16.39 19.64-22.68A28.29 28.29 0 0 1 1129.85.4c1.17-.13 3.57-.2 6.74-.24.26-.01.27-.01.27-.06z",
      style: {
        fill: "url(#" + uuid + "aNeues_Verlaufsfeld_2-2)"
      },
      transform: "translate(0 -.1)"
    }), React.createElement("path", {
      d: "M1192.84 97.55c-1.63 2.74-2.9 4.78-3.59 5.72a28.24 28.24 0 0 1-9.53 7.86c-10.33 5.29-23.29 5.66-29.48 5.66H1065c-6.18 0-19.15-.37-29.47-5.66a28.27 28.27 0 0 1-9.53-7.86c-.69-.95-2-3-3.58-5.71a.46.46 0 0 0-.2-.22l3.61 6.24 32.59 56.48a.17.17 0 0 0 .1 0h98.17a.09.09 0 0 0 .09-.05L1193 97.33a.46.46 0 0 0-.16.22z",
      style: {
        fill: "url(#" + uuid + "aNeues_Verlaufsfeld_2-3)"
      },
      transform: "translate(0 -.1)"
    }), React.createElement("path", {
      d: "M1200 85.17l-49.1-85a.09.09 0 0 0-.09-.05h-14l-.25.06c-3.17 0-5.57.11-6.74.24a28.29 28.29 0 0 0-11.59 4.33 49.65 49.65 0 0 0-10.62 9.63 87.82 87.82 0 0 1 9 13.06L1138 64.31s14 24.31 21.29 36.89c3.09 5.35 9.25 16.77 9.82 28.36a28.4 28.4 0 0 1-2 12.18c-.47 1.08-1.62 3.2-3.17 6a.68.68 0 0 0-.11.31L1200 85.27a.19.19 0 0 0 0-.1z",
      style: {
        fill: "url(#" + uuid + "aNeues_Verlaufsfeld_2-4)"
      },
      transform: "translate(0 -.1)"
    })), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
      d: "M42 131.59c13.25 0 23.46-4.77 31.28-13.72l-11.51-11.81c-4.79 5.12-10.85 7.81-18.68 7.81-13.56 0-22.66-11.31-22.66-26.49C20.43 72.7 29.69 61 42.77 61a24.66 24.66 0 0 1 17.56 7.19l12-12.44a39.31 39.31 0 0 0-29.24-12.43C19.16 43.32 0 63.12 0 87.86c0 25.87 18.83 43.73 42 43.73zM123.92 114.2c-14.69 0-24.11-11.64-24.11-26.82 0-14.36 9.1-26.66 24.11-26.66 14.68 0 24.1 11.66 24.1 26.81 0 14.38-9.1 26.67-24.1 26.67zm-.33 17.39a44 44 0 0 0 44.53-44.53c0-24.89-18-43.74-43.89-43.74a44.05 44.05 0 0 0-44.52 44.54c0 24.91 18 43.73 43.89 43.73zM239 130l14.37-46.77c2.55-8.14 4.46-17.39 4.46-17.39h.32s.16 9.25 1 18.52L262.9 130h18.82l-8.29-85.23h-24.74l-12.93 42.29c-2.07 6.88-4.31 15.65-4.31 15.65s-2.22-8.77-4.45-15.81l-13.11-42.13h-25.22L180.38 130h17.71l3.84-46c.79-8.94 1-18.19 1-18.19h.32s2.08 9.25 4.63 17.72L222.19 130H239zM357.86 130l14.36-46.77c2.56-8.14 4.48-17.39 4.48-17.39h.3s.17 9.25 1 18.52l3.8 45.64h18.84l-8.31-85.23H367.6l-12.93 42.29c-2.08 6.88-4.31 15.65-4.31 15.65s-2.24-8.78-4.47-15.81L332.8 44.77h-25.22l-8.3 85.23H317l3.83-46c.8-8.94 1-18.19 1-18.19h.32s2.07 9.25 4.63 17.72L341.1 130h16.76z",
      transform: "translate(0 -.1)"
    }), React.createElement("path", {
      d: "M421.03 129.9h55.39v-16.27h-36.87V94.95h31.28V78.98h-31.28V60.94h36.39V44.68h-54.91v85.22z"
    }), React.createElement("path", {
      d: "M540.19 72.07c0 8-5.26 11.34-15.65 11.34h-7.65V60.72h7.65c9.91 0 15.65 3 15.65 11.35zM563 130l-20.9-34.32c11-4.15 17.24-12.6 17.24-23.61 0-17.25-9.74-27.29-35.43-27.29h-25.54V130h18.52V99h5.9L541 130h22z",
      transform: "translate(0 -.1)"
    }), React.createElement("path", {
      d: "M573.95 129.9h59.37v-16.27h-36.08l35.28-54.9V44.68h-57.77v16.26h34.46l-35.26 54.92v14.04z"
    }), React.createElement("path", {
      d: "M671 94.89h13.74c8.29 0 13.57 2.55 13.57 9.25 0 6.54-4.14 9.89-13.57 9.89H671V94.89zm0-34.17h10.71c5.89 0 11.8 1.93 11.8 9 0 6.86-5.1 9.56-11 9.56H671V60.72zM652.54 130h32.57c15.16 0 32.08-6.86 32.08-24.58 0-11-7-18.36-18.18-19.79v-.16c8.76-2.71 14.2-9.41 14.2-18.83 0-18.52-16.29-21.87-31.14-21.87h-29.53V130zM742.07 130l5.93-17.39h33.2l5.87 17.39H807l-30.32-85.23h-23L723.37 130h18.69zm33.67-33.35h-22.36l7.51-22.51C763 67.75 764.57 62 764.57 62s1.6 5.74 3.67 12l7.5 22.67zM818.59 130h17.25V89.46c0-7.66-.48-15.48-.48-15.48s4 6.86 8.45 13.55L872.69 130h16.44V44.77h-17.24v38.64c0 7.63.5 15.48.5 15.48s-4-6.87-8.47-13.58l-27.61-40.54h-17.72V130z",
      transform: "translate(0 -.1)"
    }), React.createElement("path", {
      d: "M909.62 44.68v85.22h18.52V90l27.3 39.9h22.82l-31.27-45.64 28.24-39.58h-21.39l-25.7 38.31V44.68h-18.52z"
    })))), React.createElement("svg", {
      className: CSSPrefix_1.lsgPre + "logo-svg " + CSSPrefix_1.lsgPre + "logo-small",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 184.73 160",
      focusable: "false"
    }, React.createElement("defs", null, React.createElement("radialGradient", {
      id: uuid + "bNeues_Verlaufsfeld_2",
      cx: "105.06",
      cy: "92.83",
      r: "36.47",
      gradientTransform: "matrix(3.91 0 0 3.91 -258.57 -221.2)",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      offset: "0",
      stopColor: "#ffe319"
    }), React.createElement("stop", {
      offset: ".2",
      stopColor: "#fdd70d"
    }), React.createElement("stop", {
      offset: ".48",
      stopColor: "#facb00"
    }), React.createElement("stop", {
      offset: ".63",
      stopColor: "#f8c700"
    }), React.createElement("stop", {
      offset: ".78",
      stopColor: "#f1bb00"
    }), React.createElement("stop", {
      offset: ".89",
      stopColor: "#eaae00"
    }), React.createElement("stop", {
      offset: ".92",
      stopColor: "#e4a500"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#d89300"
    })), React.createElement("radialGradient", {
      id: uuid + "bNeues_Verlaufsfeld_2-2",
      cx: "95.31",
      cy: "56.57",
      r: "36.4",
      xlinkHref: "#" + uuid + "bNeues_Verlaufsfeld_2"
    }), React.createElement("radialGradient", {
      id: uuid + "bNeues_Verlaufsfeld_2-3",
      cx: "69.03",
      cy: "83.22",
      r: "36.31",
      xlinkHref: "#" + uuid + "bNeues_Verlaufsfeld_2"
    }), React.createElement("radialGradient", {
      id: uuid + "bNeues_Verlaufsfeld_2-4",
      cx: "105.06",
      cy: "92.68",
      r: "36.47",
      xlinkHref: "#" + uuid + "bNeues_Verlaufsfeld_2"
    })), React.createElement("g", null, React.createElement("path", {
      d: "M103.62 5A28.25 28.25 0 0 1 115.15.6c2.6-.28 11.15-.17 20.9-.17a.14.14 0 0 1 .1.06l-.26-.43A1.58 1.58 0 0 0 135 0h-18.42C114 0 104 0 92.47 14l.45.54A51.57 51.57 0 0 1 103.62 5z",
      style: {
        fill: "url(#" + uuid + "bNeues_Verlaufsfeld_2)"
      },
      transform: "translate(-.27)"
    }), React.createElement("path", {
      d: "M121.86 0H49.48a.12.12 0 0 0-.1 0L13.14 62.83 1.77 82.51.45 84.8l-.17.29a.08.08 0 0 0 0 .11l34.88 60.42a6.72 6.72 0 0 0-.37-.88c-.73-1.37-1.28-2.43-1.58-3.1a28.18 28.18 0 0 1-2-12.18c.58-11.58 6.73-23 9.81-28.36 7.27-12.58 21.31-36.89 21.31-36.89s14-24.32 21.29-36.9c3.09-5.31 9.92-16.39 19.64-22.68A28.29 28.29 0 0 1 114.85.3c1.17-.13 3.57-.2 6.74-.24.26-.06.27-.06.27-.06z",
      style: {
        fill: "url(#" + uuid + "bNeues_Verlaufsfeld_2-2)"
      },
      transform: "translate(-.27)"
    }), React.createElement("path", {
      d: "M177.84 97.46c-1.63 2.74-2.9 4.78-3.59 5.72a28.24 28.24 0 0 1-9.53 7.86c-10.33 5.29-23.29 5.66-29.48 5.66H50c-6.18 0-19.15-.37-29.47-5.66a28.27 28.27 0 0 1-9.53-7.86c-.69-.95-2-3-3.58-5.71a.46.46 0 0 0-.2-.22l3.61 6.24L43.45 160a.17.17 0 0 0 .1 0h98.17a.09.09 0 0 0 .09-.05L178 97.23a.46.46 0 0 0-.16.23z",
      style: {
        fill: "url(#" + uuid + "bNeues_Verlaufsfeld_2-3)"
      },
      transform: "translate(-.27)"
    }), React.createElement("path", {
      d: "M185 85.07l-49.1-85a.09.09 0 0 0-.09-.07h-14l-.25.06c-3.17 0-5.57.11-6.74.24a28.29 28.29 0 0 0-11.59 4.33 49.65 49.65 0 0 0-10.62 9.62 87.82 87.82 0 0 1 9 13.06L123 64.21s14 24.31 21.29 36.89c3.09 5.35 9.25 16.77 9.82 28.36a28.4 28.4 0 0 1-2 12.18c-.47 1.08-1.62 3.2-3.17 6a.68.68 0 0 0-.11.31L185 85.17a.19.19 0 0 0 0-.1z",
      style: {
        fill: "url(#" + uuid + "bNeues_Verlaufsfeld_2-4)"
      },
      transform: "translate(-.27)"
    })))), React.createElement("span", {
      className: CSSPrefix_1.lsgPre + "logo-monochrome"
    }, React.createElement("svg", {
      className: CSSPrefix_1.lsgPre + "logo-svg " + CSSPrefix_1.lsgPre + "logo-big",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1201 160.13",
      focusable: "false"
    }, React.createElement("defs", null), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
      d: "M42 131.78c13.26 0 23.48-4.78 31.31-13.73l-11.5-11.83C57 111.34 51 114 43.13 114c-13.57 0-22.68-11.32-22.68-26.51 0-14.69 9.26-26.37 22.36-26.37a24.68 24.68 0 0 1 17.58 7.19l12-12.45a39.33 39.33 0 0 0-29.26-12.43C19.17 43.43 0 63.25 0 88c0 25.89 18.85 43.77 42 43.77zM124 114.37c-14.7 0-24.13-11.66-24.13-26.84C99.9 73.16 109 60.85 124 60.85c14.69 0 24.12 11.67 24.12 26.83 0 14.39-9.11 26.7-24.12 26.7zm-.33 17.41c25.4 0 44.57-20 44.57-44.57 0-24.91-18-43.78-43.92-43.78A44.09 44.09 0 0 0 79.77 88c0 24.93 18.05 43.77 43.92 43.77zM239.15 130.19l14.38-46.81C256.08 75.23 258 66 258 66h.33s.16 9.26 1 18.53l3.84 45.68H282l-8.3-85.3h-24.8L236 87.21c-2.07 6.88-4.31 15.67-4.31 15.67s-2.23-8.79-4.48-15.82l-13.1-42.16h-25.28l-8.3 85.3h17.73l3.84-46c.79-9 1-18.21 1-18.21h.32s2.08 9.26 4.63 17.74l14.38 46.48h16.77zM358.16 130.19l14.38-46.81C375.09 75.23 377 66 377 66h.31s.17 9.26 1 18.53l3.84 45.68H401l-8.31-85.3H367.9L355 87.21c-2.08 6.88-4.31 15.67-4.31 15.67s-2.24-8.79-4.48-15.82l-13.1-42.16h-25.27l-8.31 85.3h17.73l3.84-46c.8-9 1-18.21 1-18.21h.32s2.07 9.26 4.63 17.74l14.38 46.48h16.78z",
      transform: "translate(0 -.08)"
    }), React.createElement("path", {
      d: "M421.38 130.11h55.43v-16.28h-36.9v-18.7h31.31V79.15h-31.31V61.09h36.42V44.81h-54.95v85.3z"
    }), React.createElement("path", {
      d: "M540.64 72.21c0 8-5.27 11.35-15.66 11.35h-7.66V60.85H525c9.91 0 15.66 3 15.66 11.36zm22.84 58l-20.93-34.37c11-4.15 17.25-12.61 17.25-23.63 0-17.26-9.75-27.32-35.46-27.32h-25.55v85.3h18.53v-31h5.91l18.21 31h22z",
      transform: "translate(0 -.08)"
    }), React.createElement("path", {
      d: "M574.43 130.11h59.41v-16.28h-36.1l35.31-54.95V44.81h-57.82v16.28h34.49l-35.29 54.97v14.05z"
    }), React.createElement("path", {
      d: "M671.61 95h13.75c8.3 0 13.58 2.55 13.58 9.26 0 6.54-4.14 9.9-13.58 9.9h-13.75V95zm0-34.2h10.72c5.89 0 11.81 1.93 11.81 9 0 6.86-5.1 9.57-11 9.57h-11.53V60.85zm-18.52 69.34h32.6c15.17 0 32.11-6.86 32.11-24.6 0-11-7-18.37-18.2-19.81v-.11c8.76-2.72 14.21-9.41 14.21-18.84 0-18.53-16.3-21.88-31.16-21.88h-29.57v85.3zM742.68 130.19l5.89-17.41h33.23l5.91 17.41h20l-30.35-85.3h-23L724 130.19h18.71zm33.7-33.38H754l7.52-22.53c2.07-6.39 3.68-12.14 3.68-12.14s1.6 5.75 3.67 12l7.51 22.68zM819.27 130.19h17.26V89.61c0-7.66-.48-15.49-.48-15.49s4 6.86 8.45 13.56l28.91 42.51h16.45v-85.3h-17.25v38.66c0 7.64.5 15.49.5 15.49s-4-6.87-8.48-13.6L837 44.89h-17.73v85.3z",
      transform: "translate(0 -.08)"
    }), React.createElement("path", {
      d: "M910.38 44.81v85.3h18.53V90.17l27.32 39.94h22.84l-31.3-45.68 28.27-39.62h-21.41l-25.72 38.35V44.81h-18.53z"
    }))), React.createElement("path", {
      d: "M1201 85.23L1151.86.13a.12.12 0 0 0-.1-.06h-4a31 31 0 0 0-12.26 2.64 42 42 0 0 0-15.12 11.66l-6.27 7.34c1.46 2.19 2.63 4.18 3.51 5.7l21.32 36.92s14 24.33 21.32 36.92a89.88 89.88 0 0 1 6.81 14.36c.68 1.85 3 8.68 3.88 12a53.48 53.48 0 0 1 1.43 7.36L1201 85.33a.14.14 0 0 0 0-.1zM1159.81 156.66a30.94 30.94 0 0 0 3.85-11.93 41.92 41.92 0 0 0-2.53-18.93c-.19-.54-2-5.56-3.23-9.1-2.64.16-4.94.19-6.69.19h-85.27a89.15 89.15 0 0 1-15.83-1.28c-1.94-.33-9-1.74-12.31-2.63a51 51 0 0 1-7.1-2.44l28.65 49.62a.09.09 0 0 0 .09 0h98.26a.14.14 0 0 0 .09 0l2-3.5zM1108.57 14.34c1.26-1.51 6-6.93 8.43-9.34a54.46 54.46 0 0 1 5.65-4.92h-57.28a.12.12 0 0 0-.1.06l-47.64 82.52-1.49 2.58a.21.21 0 0 0 0 .11l2 3.49a30.94 30.94 0 0 0 8.41 9.3 41.91 41.91 0 0 0 17.66 7.26l9.5 1.76c1.17-2.37 2.3-4.37 3.17-5.9l21.32-36.92 21.32-36.92a89.19 89.19 0 0 1 9-13.07z",
      transform: "translate(0 -.08)"
    })), React.createElement("svg", {
      className: CSSPrefix_1.lsgPre + "logo-svg " + CSSPrefix_1.lsgPre + "logo-small",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 184.71 160",
      focusable: "false"
    }, React.createElement("path", {
      d: "M184.71 85.08l-49.09-85a.12.12 0 0 0-.1-.06h-4a30.93 30.93 0 0 0-12.25 2.64 42 42 0 0 0-15.1 11.65l-6.31 7.32c1.46 2.19 2.63 4.18 3.51 5.69l21.3 36.89s14 24.31 21.3 36.89a89.8 89.8 0 0 1 6.8 14.34c.68 1.85 3 8.67 3.88 12a53.43 53.43 0 0 1 1.43 7.35l28.62-49.57a.14.14 0 0 0 .01-.14zM143.56 156.45a30.91 30.91 0 0 0 3.84-11.92 41.88 41.88 0 0 0-2.54-18.91c-.19-.54-2-5.55-3.23-9.1-2.64.16-4.93.19-6.68.19H49.76a89.08 89.08 0 0 1-15.82-1.27c-1.94-.33-9-1.74-12.3-2.63a50.94 50.94 0 0 1-7.09-2.43L43.18 160a.09.09 0 0 0 .09 0h98.18a.14.14 0 0 0 .09 0l2-3.5zM92.36 14.26c1.26-1.51 6-6.92 8.42-9.34A54.41 54.41 0 0 1 106.44 0H49.2a.12.12 0 0 0-.1.06L1.5 82.51.01 85.09a.21.21 0 0 0 0 .11l2 3.48A30.91 30.91 0 0 0 10.44 98a41.87 41.87 0 0 0 17.65 7.26l9.48 1.74c1.17-2.37 2.29-4.36 3.17-5.89l21.3-36.89 21.3-36.89a89.12 89.12 0 0 1 9-13.06z"
    })))));
  };

  Logo.defaultProps = {
    size: Sizes.AUTO,
    variant: Variants.COLORED
  };
  Logo.Sizes = Sizes;
  Logo.Variants = Variants;
  return Logo;
}(React.Component);

exports.Logo = Logo;